module.exports = __webpack_public_path__ + "img/mahe_1_ocular.f689bf28.jpg";